import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, NaturezaOperacao, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from '@mui/material'
import { selectUser } from '../Redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { NaturezaOperacaoService } from '../../Pages/NaturezaOperacao/NaturezaOperacaoService'
import moment from 'moment'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    naturezaOperacao: NaturezaOperacao[],
    handleUpdateNaturazaOperacaoList: () => void,
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number
    descricao: string
    cfop_entrada: string
    cfop_saida: string
    cfop_interno: string
    cfop_externo: string
    cst_dentro: string
    cst_fora: string
    dt_cadastro: string
}

export const GridNaturezaOperacao = React.memo(({ naturezaOperacao, handleUpdateNaturazaOperacaoList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_NatOp")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_NatOp") || '')
                : {
                    acao: true,
                    descricao: true,
                    cfop_entrada: true,
                    cfop_saida: true,
                    cfop_interno: true,
                    cfop_externo: true,
                    cst_dentro: true,
                    cst_fora: true,
                    dt_cadastro: true,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_NatOp")

    let json: any = {
        acao: true,
        descricao: true,
        cfop_entrada: true,
        cfop_saida: true,
        cfop_interno: true,
        cfop_externo: true,
        cst_dentro: true,
        cst_fora: true,
        dt_cadastro: true,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_NatOp") || '')
    }
    */

    const [idNat, setIdNat] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [naturezaOperacoes, setNaturezaOperacoes] = useState<NaturezaOperacao[]>([])
    const [nomeNatOp, setNatOp] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setNaturezaOperacoes(naturezaOperacao)
    }, [naturezaOperacao])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_NatOp", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await NaturezaOperacaoService.Delete(idNat, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Natureza de operação excluída com sucesso`)

                handleUpdateNaturazaOperacaoList()

                //setModalShow(false)
                //setNaturezaOperacoes(await NaturezaOperacaoService.Filter('', '', ''))

            } else {
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setFeedBackVisible(true)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Ocorreu um erro ao excluir a natureza de operação. Tente novamente`)

        } 
        
    }, [idNat])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_natOp")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNatOp("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNatOp("")
    }, [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },

        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- CODIGO SEM USO --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }

                newColumnVisibility.acao = json.acao
                newColumnVisibility.descricao = json.descricao
                newColumnVisibility.cfop_entrada = json.cfop_entrada
                newColumnVisibility.cfop_saida = json.cfop_saida
                newColumnVisibility.cfop_interno = json.cfop_interno
                newColumnVisibility.cfop_externo = json.cfop_externo
                newColumnVisibility.cst_dentro = json.cst_dentro
                newColumnVisibility.cst_fora = json.cst_fora
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    */


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaNatEdit = (id: number) => {
        navigate(`/naturezaOperacao/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<NaturezaOperacao>[]>(() => [
        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: false, enableSorting: false, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaNatEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdNat(rowData.id)
                        setNatOp(rowData.descricao)
                        setModalShow(true)
    
                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }
    
                        let menuFiltro = document.getElementById("divMenuFiltroNat") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsNat") as HTMLDivElement
    
                        if (menuFiltro) {
    
                            menuInputs.classList.add("invisible")
    
                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[390px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0);

                }

                return (
                    <div className={`flex justify-start w-full`}>

                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                      bg-sky-500`}>
                            <RiEdit2Fill size="20px" />
                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                            </Tooltip>
                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                      bg-red-500 ml-2`} >
                            <FaTrashAlt size="18px" />
                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                            </Tooltip>
                        </button>

                    </div>
                )
            }
        },

        {
            accessorKey: 'descricao', visibleInShowHideMenu: true, header: 'Descrição', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.descricao ? rowData.descricao : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfop_entrada', visibleInShowHideMenu: true, header: 'CFOP de Entrada de Serviços do Estado', size: 350, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfop_entrada ? rowData.cfop_entrada : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfop_interno', visibleInShowHideMenu: true, header: 'CFOP de Entrada de Serviços de Outros Estados', size: 400, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfop_interno ? rowData.cfop_interno : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfop_saida', visibleInShowHideMenu: true, header: 'CFOP de Saida de Serviços do Estado', size: 350, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfop_saida ? rowData.cfop_saida : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cfop_externo', visibleInShowHideMenu: true, header: 'CFOP de Saida de Serviços de Outros Estados', size: 400, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cfop_externo ? rowData.cfop_externo : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cst_dentro', visibleInShowHideMenu: true, header: 'Cst Dentro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cst_dentro ? rowData.cst_dentro : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cst_fora', visibleInShowHideMenu: true, header: 'Cst Fora', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },


            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cst_fora ? rowData.cst_fora : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

    ], [])

    const table = useMaterialReactTable({
        columns: colunas,
        data: naturezaOperacoes,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a natureza - ${nomeNatOp || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})